var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'node-text', _vm.item.classes ]},_vm._l((_vm.lines),function(line,index){return _c('p',{key:index,class:_vm.getLineClasses(line),domProps:{"innerHTML":_vm._s(_vm.getLine(line))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }